module.exports = __webpack_public_path__ + "static/media/lcg-shape-purple-down-long.eea4f8e9.svg";